// Make/Model specific maintenance schedules
// These override the defaults when a specific make/model is detected

export const MAKE_MODEL_SCHEDULES = {
  // PORSCHE
  porsche: {
    default: {
      oil_change: { miles: 10000, months: 12 },
      brake_fluid: { miles: 20000, months: 24 },
      spark_plugs: { miles: 40000, months: 48 },
      coolant_flush: { miles: 40000, months: 48 },
      air_filter: { miles: 40000, months: 48 },
      transmission_fluid: { miles: 60000, months: 72 },
    },
    '911': {
      oil_change: { miles: 10000, months: 12 },
      brake_pads: { miles: 20000, months: 24 }, // Track use = faster wear
      brake_fluid: { miles: 20000, months: 24 },
      timing_chain: { miles: 120000, months: 120 }, // Chain, not belt
    },
    'Cayenne': {
      oil_change: { miles: 10000, months: 12 },
      differential_fluid: { miles: 40000, months: 48 },
      transmission_fluid: { miles: 60000, months: 72 },
    },
    'Boxster': {
      oil_change: { miles: 10000, months: 12 },
      spark_plugs: { miles: 40000, months: 48 },
    },
    'Cayman': {
      oil_change: { miles: 10000, months: 12 },
      spark_plugs: { miles: 40000, months: 48 },
    }
  },

  // FERRARI
  ferrari: {
    default: {
      oil_change: { miles: 7500, months: 12 },
      brake_fluid: { miles: 15000, months: 24 },
      timing_belt: { miles: 37500, months: 60 }, // Critical for Ferrari!
      spark_plugs: { miles: 22500, months: 36 },
      coolant_flush: { miles: 37500, months: 60 },
      transmission_fluid: { miles: 22500, months: 36 },
      clutch_inspection: { miles: 15000, months: 24 },
    },
    '488': {
      oil_change: { miles: 12500, months: 12 },
      timing_belt: { miles: 37500, months: 60 },
    },
    'F430': {
      timing_belt: { miles: 30000, months: 60 }, // Very important!
    },
    '360': {
      timing_belt: { miles: 30000, months: 60 },
      cam_seal: { miles: 30000, months: 60 },
    },
    '355': {
      timing_belt: { miles: 30000, months: 36 }, // Shorter interval on older models
      major_service: { miles: 30000, months: 36 },
    }
  },

  // LAMBORGHINI
  lamborghini: {
    default: {
      oil_change: { miles: 9000, months: 12 },
      brake_fluid: { miles: 18000, months: 24 },
      spark_plugs: { miles: 27000, months: 36 },
      transmission_fluid: { miles: 27000, months: 36 },
      timing_belt: { miles: 36000, months: 60 },
    },
    'Huracan': {
      oil_change: { miles: 9000, months: 12 },
    },
    'Gallardo': {
      timing_belt: { miles: 36000, months: 60 },
      clutch_inspection: { miles: 18000, months: 24 },
    }
  },

  // BMW
  bmw: {
    default: {
      oil_change: { miles: 10000, months: 12 }, // BMW says 15k but most recommend 10k
      brake_fluid: { miles: 30000, months: 24 },
      spark_plugs: { miles: 60000, months: 60 },
      coolant_flush: { miles: 60000, months: 60 },
      transmission_fluid: { miles: 60000, months: 72 }, // "Lifetime" is not realistic
      air_filter: { miles: 30000, months: 36 },
      cabin_air_filter: { miles: 20000, months: 24 },
    },
    'M3': {
      oil_change: { miles: 7500, months: 12 },
      differential_fluid: { miles: 30000, months: 36 },
      brake_pads: { miles: 25000, months: 30 },
    },
    'M5': {
      oil_change: { miles: 7500, months: 12 },
      differential_fluid: { miles: 30000, months: 36 },
      transmission_fluid: { miles: 50000, months: 60 },
    }
  },

  // MERCEDES-BENZ
  'mercedes-benz': {
    default: {
      oil_change: { miles: 10000, months: 12 }, // Service A
      brake_fluid: { miles: 20000, months: 24 }, // Service B
      spark_plugs: { miles: 60000, months: 60 },
      transmission_fluid: { miles: 60000, months: 72 },
      coolant_flush: { miles: 60000, months: 60 },
      air_filter: { miles: 40000, months: 48 },
    },
    'AMG GT': {
      oil_change: { miles: 6500, months: 12 },
      brake_fluid: { miles: 15000, months: 24 },
    },
    'SL': {
      oil_change: { miles: 10000, months: 12 },
      convertible_top: { miles: null, months: 24 },
    }
  },

  // AUDI
  audi: {
    default: {
      oil_change: { miles: 10000, months: 12 },
      brake_fluid: { miles: 20000, months: 24 },
      spark_plugs: { miles: 60000, months: 60 },
      transmission_fluid: { miles: 60000, months: 72 },
      timing_chain: { miles: 120000, months: 120 },
    },
    'R8': {
      oil_change: { miles: 9000, months: 12 },
      clutch_inspection: { miles: 15000, months: 24 },
    },
    'RS6': {
      oil_change: { miles: 7500, months: 12 },
    }
  },

  // LAND ROVER
  'land rover': {
    default: {
      oil_change: { miles: 16000, months: 12 }, // LR says 21k, conservative is better
      brake_fluid: { miles: 30000, months: 24 },
      coolant_flush: { miles: 60000, months: 60 },
      differential_fluid: { miles: 60000, months: 60 },
      transmission_fluid: { miles: 60000, months: 72 },
      air_filter: { miles: 30000, months: 36 },
      air_suspension: { miles: null, months: 60 },
    },
    'Defender': {
      oil_change: { miles: 12000, months: 12 },
      differential_fluid: { miles: 40000, months: 48 },
    },
    'Range Rover': {
      oil_change: { miles: 12000, months: 12 },
      air_suspension: { miles: null, months: 48 },
    }
  },

  // TOYOTA/LEXUS
  toyota: {
    default: {
      oil_change: { miles: 10000, months: 12 }, // With synthetic
      brake_fluid: { miles: 30000, months: 36 },
      coolant_flush: { miles: 100000, months: 120 }, // Super Long Life coolant
      transmission_fluid: { miles: 60000, months: 72 },
      spark_plugs: { miles: 120000, months: 120 }, // Iridium
    },
    'Land Cruiser': {
      oil_change: { miles: 10000, months: 12 },
      differential_fluid: { miles: 30000, months: 36 },
    },
    'Supra': {
      oil_change: { miles: 10000, months: 12 },
    }
  },

  lexus: {
    default: {
      oil_change: { miles: 10000, months: 12 },
      brake_fluid: { miles: 30000, months: 36 },
      coolant_flush: { miles: 100000, months: 120 },
      transmission_fluid: { miles: 60000, months: 72 },
      spark_plugs: { miles: 120000, months: 120 },
    },
    'LFA': {
      oil_change: { miles: 7500, months: 12 },
    },
    'LC': {
      oil_change: { miles: 10000, months: 12 },
    }
  },

  // FORD
  ford: {
    default: {
      oil_change: { miles: 7500, months: 12 },
      brake_fluid: { miles: 30000, months: 36 },
      coolant_flush: { miles: 60000, months: 60 },
      transmission_fluid: { miles: 60000, months: 72 },
      spark_plugs: { miles: 60000, months: 60 },
    },
    'GT': {
      oil_change: { miles: 5000, months: 12 },
      brake_fluid: { miles: 20000, months: 24 },
    },
    'Mustang': {
      oil_change: { miles: 7500, months: 12 },
      differential_fluid: { miles: 30000, months: 36 },
    },
    'Bronco': {
      oil_change: { miles: 7500, months: 12 },
      differential_fluid: { miles: 30000, months: 36 },
    }
  },

  // CHEVROLET
  chevrolet: {
    default: {
      oil_change: { miles: 7500, months: 12 },
      brake_fluid: { miles: 30000, months: 36 },
      coolant_flush: { miles: 100000, months: 120 }, // Dex-Cool
      transmission_fluid: { miles: 60000, months: 72 },
      spark_plugs: { miles: 60000, months: 60 },
    },
    'Corvette': {
      oil_change: { miles: 7500, months: 12 },
      differential_fluid: { miles: 30000, months: 36 },
      brake_pads: { miles: 25000, months: 30 },
    }
  },

  // ASTON MARTIN
  'aston martin': {
    default: {
      oil_change: { miles: 10000, months: 12 },
      brake_fluid: { miles: 20000, months: 24 },
      spark_plugs: { miles: 40000, months: 48 },
      transmission_fluid: { miles: 40000, months: 48 },
      coolant_flush: { miles: 40000, months: 48 },
    },
    'DB11': {
      oil_change: { miles: 10000, months: 12 },
    },
    'Vantage': {
      oil_change: { miles: 10000, months: 12 },
    }
  },

  // MCLAREN
  mclaren: {
    default: {
      oil_change: { miles: 9000, months: 12 },
      brake_fluid: { miles: 18000, months: 24 },
      transmission_fluid: { miles: 36000, months: 36 },
      coolant_flush: { miles: 54000, months: 60 },
      spark_plugs: { miles: 36000, months: 36 },
    }
  },

  // BENTLEY
  bentley: {
    default: {
      oil_change: { miles: 10000, months: 12 },
      brake_fluid: { miles: 20000, months: 24 },
      spark_plugs: { miles: 40000, months: 48 },
      transmission_fluid: { miles: 40000, months: 48 },
      coolant_flush: { miles: 60000, months: 60 },
    }
  },

  // ROLLS-ROYCE
  'rolls-royce': {
    default: {
      oil_change: { miles: 10000, months: 12 },
      brake_fluid: { miles: 20000, months: 24 },
      coolant_flush: { miles: 40000, months: 48 },
      transmission_fluid: { miles: 60000, months: 72 },
      spark_plugs: { miles: 60000, months: 60 },
      air_suspension: { miles: null, months: 48 },
    }
  },

  // CLASSIC AMERICAN
  // General guidelines for classic cars
  classic: {
    default: {
      oil_change: { miles: 3000, months: 6 }, // Conventional oil
      brake_fluid: { miles: 20000, months: 24 },
      coolant_flush: { miles: 24000, months: 24 },
      transmission_fluid: { miles: 30000, months: 36 },
      differential_fluid: { miles: 30000, months: 36 },
      spark_plugs: { miles: 12000, months: 24 },
      points_condenser: { miles: 12000, months: 24 }, // If equipped
      carb_adjustment: { miles: null, months: 12 },
      valve_adjustment: { miles: 15000, months: 24 },
    }
  }
}

// Get maintenance schedule for a specific make/model
export function getMakeModelSchedule(make, model) {
  const makeLower = make?.toLowerCase().trim()
  const modelLower = model?.toLowerCase().trim()

  // Find make
  const makeSchedule = MAKE_MODEL_SCHEDULES[makeLower]
  if (!makeSchedule) {
    // Return null to use defaults
    return null
  }

  // Check for model-specific overrides
  const modelSchedule = Object.keys(makeSchedule).find(key =>
    key !== 'default' && modelLower?.includes(key.toLowerCase())
  )

  // Merge default with model-specific
  return {
    ...makeSchedule.default,
    ...(modelSchedule ? makeSchedule[modelSchedule] : {})
  }
}

// Determine vehicle category from year
export function getVehicleCategory(year, make) {
  const yearNum = parseInt(year)
  const makeLower = make?.toLowerCase()

  // Exotic/supercar makes
  const exoticMakes = ['ferrari', 'lamborghini', 'mclaren', 'bugatti', 'pagani', 'koenigsegg']
  if (exoticMakes.includes(makeLower)) return 'exotic'

  // Luxury performance
  const luxuryPerformance = ['porsche', 'aston martin', 'bentley', 'rolls-royce']
  if (luxuryPerformance.includes(makeLower)) return 'sports_car'

  // Classic if pre-1985
  if (yearNum && yearNum < 1985) return 'classic_car'

  // Vintage if pre-1970
  if (yearNum && yearNum < 1970) return 'classic_car'

  // Default to modern
  return 'modern_daily'
}

// Special maintenance items for certain makes
export const SPECIAL_MAINTENANCE = {
  ferrari: [
    { id: 'cam_belt_service', name: 'Cam Belt Service', miles: 37500, months: 60, severity: 'critical' },
    { id: 'sticky_buttons', name: 'Sticky Button Restoration', miles: null, months: 60, severity: 'low' },
  ],
  porsche: [
    { id: 'ims_bearing', name: 'IMS Bearing (996/997.1)', miles: null, months: null, severity: 'critical', note: 'One-time preventive replacement recommended' },
    { id: 'bore_score_inspection', name: 'Bore Score Inspection (991/992)', miles: 30000, months: 36, severity: 'medium' },
  ],
  'land rover': [
    { id: 'air_suspension_service', name: 'Air Suspension Service', miles: null, months: 48, severity: 'medium' },
    { id: 'sunroof_drains', name: 'Sunroof Drain Cleaning', miles: null, months: 24, severity: 'low' },
  ],
  bmw: [
    { id: 'vanos_service', name: 'VANOS Service', miles: 70000, months: 84, severity: 'medium' },
    { id: 'cooling_system', name: 'Cooling System Overhaul', miles: 80000, months: 96, severity: 'high' },
  ],
  'mercedes-benz': [
    { id: 'abc_fluid', name: 'ABC Suspension Fluid', miles: 30000, months: 36, severity: 'medium' },
  ]
}
